import React from 'react';

export default function OverviewPanel({ stats, myAnimals, onViewAll, onAddAnimal }) {
  const statCards = [
    { label: 'Total Listings',   value: stats.totalListings,   icon: 'pets',         color: 'text-primary',     bg: 'bg-primary/10'  },
    { label: 'Active Listings',  value: stats.activeListings,  icon: 'check_circle', color: 'text-emerald-600', bg: 'bg-emerald-50'  },
    { label: 'Pending Review',   value: stats.pendingListings, icon: 'pending',      color: 'text-amber-600',   bg: 'bg-amber-50'    },
    { label: 'Total Revenue',    value: `₹${Number(stats.totalRevenue||0).toLocaleString('en-IN')}`,
                                                                icon: 'payments',     color: 'text-blue-600',    bg: 'bg-blue-50'     },
  ];

  return (
    <div className="space-y-6">
      {/* Stat cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {statCards.map(s => (
          <div key={s.label}
            className="bg-white rounded-2xl p-3 sm:p-5 shadow-sm border border-outline-variant/10
                       hover:border-primary/20 transition-all flex items-start justify-between">
            <div className="flex flex-col gap-1">
              <p className="text-[9px] sm:text-[11px] font-bold uppercase tracking-widest text-secondary leading-tight">{s.label}</p>
              <p className="text-xl sm:text-3xl font-black text-on-surface mt-1">{s.value ?? '0'}</p>
              <p className={`text-xs font-bold mt-1 flex items-center gap-1 ${s.color}`}>
                <span className="material-symbols-outlined text-sm">trending_up</span>
                Live data
              </p>
            </div>
            <span className={`material-symbols-outlined ${s.color} ${s.bg} p-1.5 sm:p-2.5 rounded-xl text-[18px] sm:text-[22px] flex-shrink-0`}>
              {s.icon}
            </span>
          </div>
        ))}
      </div>

      {/* Recent listings */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-outline-variant/10">
        <div className="flex justify-between items-center mb-5">
          <h3 className="font-bold text-lg">My Recent Listings</h3>
          <div className="flex gap-2">
            <button onClick={onAddAnimal}
              className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-primary text-white
                         text-xs font-bold hover:opacity-90 transition-all">
              <span className="material-symbols-outlined text-sm">add</span> Add Animal
            </button>
            <button onClick={onViewAll} className="text-xs font-bold text-primary hover:underline">
              View All →
            </button>
          </div>
        </div>

        {myAnimals.length === 0 ? (
          <div className="py-10 text-center text-secondary">
            <span className="material-symbols-outlined text-4xl text-outline-variant">pets</span>
            <p className="mt-2 text-sm font-medium">No listings yet</p>
            <button onClick={onAddAnimal}
              className="mt-4 px-4 py-2 rounded-full bg-primary text-white text-xs font-bold">
              Add your first animal
            </button>
          </div>
        ) : (
          <>
            {/* Mobile — card list */}
            <div className="md:hidden space-y-3">
              {myAnimals.slice(0, 5).map(a => (
                <div key={a.id} className="flex items-center gap-3 p-3 rounded-xl bg-surface-container-low/40">
                  {a.image_url
                    ? <img src={a.image_url} alt={a.name} className="w-12 h-12 rounded-xl object-cover flex-shrink-0" />
                    : <div className="w-12 h-12 rounded-xl bg-surface-container flex items-center justify-center flex-shrink-0">
                        <span className="material-symbols-outlined text-outline">pets</span>
                      </div>
                  }
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-sm truncate">{a.name}</p>
                    <p className="text-xs text-secondary">{a.category}</p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <p className="text-sm font-bold text-primary">₹{Number(a.price_inr).toLocaleString('en-IN')}</p>
                    <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${
                      a.status === 'active'  ? 'bg-emerald-100 text-emerald-700' :
                      a.status === 'pending' ? 'bg-amber-100 text-amber-700' :
                      a.status === 'sold'    ? 'bg-blue-100 text-blue-700' :
                                              'bg-gray-100 text-gray-600'
                    }`}>{a.status}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop — table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b border-surface-container-high">
                    {['Animal','Category','Price','Status'].map(h => (
                      <th key={h} className="pb-3 text-[10px] font-black uppercase tracking-widest text-secondary">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-surface-container">
                  {myAnimals.slice(0, 5).map(a => (
                    <tr key={a.id} className="hover:bg-surface-container-low/40 transition-colors">
                      <td className="py-3">
                        <div className="flex items-center gap-3">
                          {a.image_url
                            ? <img src={a.image_url} alt={a.name} className="w-10 h-10 rounded-lg object-cover" />
                            : <div className="w-10 h-10 rounded-lg bg-surface-container flex items-center justify-center">
                                <span className="material-symbols-outlined text-outline text-lg">pets</span>
                              </div>
                          }
                          <span className="text-sm font-bold">{a.name}</span>
                        </div>
                      </td>
                      <td className="py-3 text-sm text-secondary">{a.category}</td>
                      <td className="py-3 text-sm font-bold text-primary">
                        ₹{Number(a.price_inr).toLocaleString('en-IN')}
                      </td>
                      <td className="py-3">
                        <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold ${
                          a.status === 'active'  ? 'bg-emerald-100 text-emerald-700' :
                          a.status === 'pending' ? 'bg-amber-100 text-amber-700' :
                          a.status === 'sold'    ? 'bg-blue-100 text-blue-700' :
                                                  'bg-gray-100 text-gray-600'
                        }`}>{a.status}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}